/**
 * ColorModeProvider
 *
 * Initializes color mode on app load. Must be rendered at the app root
 * to ensure the color mode class is applied before any themed components render.
 */

import type { ReactNode } from 'react';
import { useColorMode } from '@/hooks/useColorMode';

interface ColorModeProviderProps {
  children: ReactNode;
}

export function ColorModeProvider({ children }: ColorModeProviderProps) {
  // This hook call ensures applyColorMode runs on mount
  useColorMode();
  return <>{children}</>;
}
